import { ObjectEvent } from './models/notifications/object-event'
import { Position } from './models/common/position'
import { Country } from './models/common/country'
import { EventMessage } from './models/notifications/event-message'
import { ObjectEventResolution } from './models/notifications/object-event-resolution'
import { LocationDescription } from './models/common/location-description'
import { VehicleObject } from './models/vehicle/vehicle-object'
import { User } from './models/users/user'
import { Address } from './models/addresses/address'
import { ObjectGroupObjects } from './models/vehicle/object-group-objects'
import { ObjectMessage } from './models/message/object-message'

/**
 * @type {Object}
 */
export const RestTypes = {
    Address: Address,
    Country: Country,
    EventMessage: EventMessage,
    LocationDescription: LocationDescription,
    ObjectEvent: ObjectEvent,
    ObjectEventResolution: ObjectEventResolution,
    ObjectGroupObjects: ObjectGroupObjects,
    ObjectMessage: ObjectMessage,
    Position: Position,
    User: User,
    VehicleObject: VehicleObject
}
